<template>
	<div class="container-fluid">

		<expense-toolbar heading="Review Expenses" icon="fa-eye"></expense-toolbar>

		<h3><i class="fa fa-eye'"></i> Review Expenses</h3>

		<p><a v-if="showAllExpenses" href="#" v-on:click.prevent="showSummaryTable = !showSummaryTable">{{showSummaryTable ? 'Hide' : 'Show'}} summary of jobs with reviewable expenses</a></p>
		<widget v-if="showSummaryTable" title="Expense Review Summary">
			<table-list
				:fields="[
					{label: 'Project/Service',key:'jobName'},
					{label: 'No. of Unreviewed Expenses',key:'expenseCount',align:'center'},
					{label: 'Reviewers',key:'reviewers'}
				]"
				:records="mutatedReviewableJobs"
				:sortable="true"
				:hide-record-count="true"
				record-name="Reviewable Job">
			</table-list>
		</widget>

		<label v-if="payPeriodButtons.length > 0">Pay Periods with Reviewable Expenses</label>
		<field :params="{type:'btn-group',buttons:payPeriodButtons}" v-model="selectedPayPeriod"></field>

		<template  v-if="mutatedExpensesToPayPeriods[selectedPayPeriod]">
			<section v-for="(user,userIndex) in mutatedExpensesToPayPeriods[selectedPayPeriod].users">
				<h3>{{ user.fullName }}</h3>

				<table-list
					:key="userIndex"
					:records="user.expenses"
					:fields="expenseTableFields"
					record-name="Expense"
					:sortable="true"
					:has-edit="true"
					id-field="slug"
					:other-buttons="[
						{text: 'Apr',icon: 'fa-check',click: 'approveRecord',class:'btn-success'}
					]"
					v-on:edit="editRecord"
					v-on:otherButtonClick="approveRecord">
				</table-list>
			</section>
		</template>

		<div v-else-if="mutatedExpensesToPayPeriods.length == 0 && expensesLoaded">
			<div class="alert alert-success text-center" style="max-width: 600px;margin:auto;margin-top: 50px;">
				<i class="fa fa-check fa-4x"></i>
				<p style="font-size: 20px">You're all caught up! No expenses to review at the moment</p>

				<button v-if="hasModulePermRead('Expenses')" class="btn btn-primary btn-lg" v-on:click="jobShowToggle(true)">
					I want to look at reviewable expenses anyway
				</button>
			</div>
		</div>

		<expense-edit-modal
			:visible="editModal.visible"
			:record="editModal.record"
			:approvable="true"
			:deleteable="false"
			:user-options-prop="userOptions()"
			:has-comments="true"
			v-on:save="saveExpense"
			v-on:closeModal="closeEditModal">
		</expense-edit-modal>

	</div>
</template>

<script>
import ExpenseToolbar from "./ExpenseToolbar"
import Field from "@/components/Field"
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import FormGroup from "@/components/FormGroup"
import ExpenseEditModal from "@/components/super_components/ExpenseEditModal"

import TimeLogMixins from "@/mixins/TimeLogMixins"

export default {

	name: 'ExpenseReview',
	components: {
		ExpenseToolbar,
		Field,
		Widget,
		TableList,
		ModalDialog,
		FormGroup,
		ExpenseEditModal
	},
	mixins: [TimeLogMixins],
	data() {
		return {
			editModal: {
				visible: false,
				record: {}
			},
			unfilteredExpenses: [],
			mutatedExpensesToPayPeriods: [],
			selectedPayPeriod: null,
			expenseTableFields: [
				{label: "#",key:"projectNum"},
				{label: "Project/Service",key: "projectName"},
				{label: "Expense Group",key: "expenseGroupName"},
				{label: "Code",key: "expenseCodeName"},
				{label: "Purchase Date",key: "purchaseDate"},
				{label: "Receipt",key: "receiptImageLink"},
				{label: "Cost",key: "totalCost",sortBy:"float",align:"right"},
				{label: "Description",key: "description"},
				{label: "Vendor",key: "vendor"},
				{label: "Payment Method",key: "payment_method"},
				{label: "Reviewed By",key: "reviewedByName"},
				{label: "Approved",key: "approvedIcon"},
				{label: "Denied Reason",key: "shortDeniedReason"}
			],
			userServices: [],
			userProjects: [],
			expensesLoaded: false,
			showAllExpenses: false,
			showSummaryTable: false
		}
	},
	computed: {
		mutatedReviewableJobs() {
			let jobs = []

			this.unfilteredExpenses.forEach(exp => {

				if ("Job" in exp && exp.Job){

					let job = jobs.find(job => exp.Job.id == job.id) 
					if (job) 
						job.expenseCount++
					
					else {

						let reviewerIds = exp.Job.JobPersonnelRole.filter(role => role.review_expenses == 1).map(role => role.user_id)

						let reviewers = exp.Job.User.filter(user => reviewerIds.indexOf(user.id) >= 0).map(user => user.first_name+" "+user.last_name).join(", ")

						jobs.push({
							id: exp.Job.id,
							jobName: exp.Job.job_num+": "+exp.Job.job_name,
							expenseCount: 1,
							reviewers: reviewers
						})
					}

					
				}
				else if ("Service" in exp && exp.Service) {
					let job = jobs.find(job => exp.Service.id == job.id)

					if (job) 
						job.expenseCount++
					
					else {

						let reviewerIds = exp.Service.JobPersonnelRole.filter(role => role.review_expenses == 1).map(role => role.user_id)

						let reviewers = exp.Service.User.filter(user => reviewerIds.indexOf(user.id) >= 0).map(user => user.first_name+" "+user.last_name).join(", ")

						jobs.push({
							id: exp.Service.id,
							jobName: exp.Service.job_num+": "+exp.Service.job_name,
							expenseCount: 1,
							reviewers: reviewers
						})
					}
				}


			})

			return jobs
		},
		payPeriodButtons() {
			let vm = this

			if (this.mutatedExpensesToPayPeriods) {
				return this.mutatedExpensesToPayPeriods.map((period,index) => {

					return {
						text: period.label,
						value: index
					}
				})
			}
			else
				return []
		}
	},
	methods: {
		closeEditModal() {
			//de-render modal so that 

			/*let vm = this
			this.editModal.visible = false

			setTimeout(() => {
				vm.editModal.render = false

				vm.$nextTick(() => {
					vm.editModal.render = true
				})
			},500)*/
			this.editModal.visible = false
		},
		editRecord(record) {

			let promises = [
				this.fetchUsers([],false,["first_name","last_name","email"]),
				this.fetchModel('ExpenseGroup')
			]

			this.spinner(true)

			let vm = this

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (record.reviewed_by == 0)
					record.approved = null

				vm.editModal.visible = true
				vm.editModal.record = record
				
			})
		},
		saveExpense(payload) {
			let vm = this

			if ("denied_reason" in payload && payload.denied_reason)
				payload.reviewed_by = this.$store.userDetails.id

			this.postData("Expense/save",payload,true).then(response => {
				if (response.success) {
					vm.fetchExpenses()
					vm.closeEditModal()
					vm.alertSaved("Expense Saved")

					if (payload.approved > 0) {
						//remove from list
						vm.editModal.record = payload
					}
				}
			})

		},
		approveRecord(record) {

			let vm = this

			let payload = {
				id: record.id,
				approved: 1,
				reviewed_by: this.$store.userDetails.id
			}

			this.saveRecord("Expense",payload, response => {
				if (response.success) {
					vm.alertSaved("Expense marked as Approved")

					//find record and remove from array
					let recordIndex = -1
					let found = false
					let user = vm.mutatedExpensesToPayPeriods[vm.selectedPayPeriod].users.find(user => user.id == record.user_id)

					recordIndex = user.expenses.findIndex(exp => record.id == exp.id)

					if (recordIndex >= 0)
						user.expenses.splice(recordIndex,1)

					if (user.expenses.length == 0) {
						//remove the user
						let userIndex = vm.mutatedExpensesToPayPeriods[vm.selectedPayPeriod].users.findIndex(user => user.id == record.user_id)

						if (userIndex >= 0) {
							vm.mutatedExpensesToPayPeriods[vm.selectedPayPeriod].users.splice(userIndex,1)

							if (vm.mutatedExpensesToPayPeriods[vm.selectedPayPeriod].users.length == 0) {

								//remove the pay period now too because its empty
								vm.mutatedExpensesToPayPeriods.splice(vm.selectedPayPeriod,1)
							}
						}

					}
					
				}
			})
			
		},
		/*groupSelected(group_id,code_id) {

			let filters = JSON.stringify([
				['group_id',group_id]
			]);

			let vm = this

			vm.spinner(true)

			this.getJSON("ExpenseCode/get?filters="+filters).then(response => {

				vm.spinner(false)

				let expenseCodesFiltered = response.data.map(code => {
					code.display = code.code + ": " + code.description

					return code
				})

				vm.expenseCodesFilteredOptions = vm.optionify(expenseCodesFiltered,"display")

				if (code_id) 
					vm.editModal.payload.code_id = code_id
	
			})
		},*/
		jobShowToggle(state) {
			let vm = this

			this.showAllExpenses = state

			this.fetchExpenses(state,true)
		},
		fetchExpenses(showAll,spinner) {
			let vm = this

			return new Promise((resolve,reject) => {

				let filters = [
					['reviewed_by',0],
					["processed",0]
				]

				if (!showAll) {

					if (vm.userServices.length > 0)
						filters.push(["service_id",vm.userServices])
					
					if (vm.userProjects.length > 0) {
						if (vm.userServices.length > 0) {
							filters.push(['reviewed_by',0,'or'])
							filters.push(['processed',0])
							filters.push(['job_id',vm.userProjects])
						}
						else
							filters.push(['job_id',vm.userProjects])
					}

					//if user is the designated accounting manager, make them the fallback for orphaned expenses
					if (vm.$store.company.accounting_manager_id == vm.$store.userDetails.id) {
						filters.push(["job_id",0,"or"])
						filters.push(["service_id",0])
						filters.push(['reviewed_by',0])
						filters.push(['processed',0])
					}
				}

				let expenseIncludes = [
					{
						model: "User",
						fields: ["first_name","last_name"]
					},
					{
						model:"ReceiptImage",
						fields: ["filename","created_at","thumb_filename","width","thumb_max_size","original_filename"]
					},
					{
						model: "Service",
						fields: ["job_num","job_name"],
						include: [{
							model: "User",
							fields: ["id","slug","first_name","last_name"]
						},
						{
							model: "JobPersonnelRole",
							fields: ["review_expenses","user_id"]
						}]
					},
					{
						model: "Job",
						fields: ["job_num","job_name"],
						include: [{
							model: "User",
							fields: ["id","slug","first_name","last_name"]
						},
						{
							model: "JobPersonnelRole",
							fields: ["review_expenses","user_id"]
						}]
					},
					{
						model: "ExpenseCode",
						fields: ["code","description","group_id"],
						include: [{model:"ExpenseGroup",fields:["group_name"]}]
					},
					{
						model: "Contact",
						fields: ["name"]
					},
					{
						model: "PurchaseOrder",
						fields: ["Supplier"],
						include: [{model: "Contact",fields: ["name"]}]
					}
				]

				if (spinner)
					vm.spinner(true,"Generating full report. This may take a few seconds...")

				vm.postData("Expense/get",{filters,include:expenseIncludes}).then(response => { //post to increase request length
					if (spinner)
						vm.spinner(false)

					if (response.success) {
						//filter expenses to only the ones that belong to a job in the filtered jobs list
						/*let filteredExpenses = response.data.filter(expense => {

							let include = false
							jobs.forEach(job => {
								if (job.id == expense.job_id)
									include = true
							})

							services.forEach(service => {
								if (service.id == expense.service_id)
									include = true
							})

							return include

						})*/

						vm.mutatedExpensesToPayPeriods = vm.mutateExpensesToPayperiods(response.data,vm.$store.timeLogSettings.interval, vm.$store.timeLogSettings.initial_payday)

						vm.unfilteredExpenses = response.data

						vm.expensesLoaded = true	
					}

					resolve(response)
				})

			})
		},
		filterToReviewExpenses(jobs) {
			let vm = this
			return jobs.filter(job => {

				let include = false
				job.JobPersonnelRole.forEach(role => {
					if (role.review_expenses == 1 && role.user_id == vm.$store.userDetails.id) 
						include = true
				})

				return include
			})
		},
		fetchData() {
			this.spinner(true)

			let vm = this

			let jobIncludes = ["JobPersonnelRole",{
				model: "User",
				fields: ["id","slug"]
			}]
			let jobFields = ["job_num","job_name"]

			let jobParams = {
				include: jobIncludes,
				fields: jobFields,
				filters: [
					["User.slug",this.$store.userDetails.slug],
					["archived",0]
				]
			}

			let jobUserParams = {
				filters: [["user_id",this.$store.userDetails.id]]
			}

			let promises = [
				this.getJSON("JobUser/get",jobUserParams),
				this.getJSON("ServiceUser/get",jobUserParams),
				//this.getJSON("Job/get",jobParams),
				//this.getJSON("Service/get",jobParams),
				this.getJSON("TimeLogSetting/get")
			]

			Promise.all(promises).then(responses => {
				//vm.spinner(false)

				let projectIds = responses[0].data.map(record => record.job_id)
				let serviceIds = responses[1].data.map(record => record.service_id)

				let projectParams = this.cloneObj(jobParams)
				projectParams.filters = [["id",projectIds],["archived",0]]

				let serviceParams = this.cloneObj(jobParams)
				serviceParams.filters = [["id",serviceIds],["archived",0]]

				let jobPromises = []

				let projectIndex = false
				let serviceIndex = false

				if (projectIds.length > 0) {
					jobPromises.push(this.postData("Job/get",projectParams))
					projectIndex = 0
				}

				if (serviceIds.length > 0) {
					jobPromises.push(this.postData("Service/get",serviceParams))

					if (projectIds.length > 0)
						serviceIndex = 1
					else
						serviceIndex = 0
				}

				Promise.all(jobPromises).then(jobResponses => {

					//filter jobs to only the ones the user is set to review expenses on
					if (projectIndex !== false)
						vm.userProjects = vm.filterToReviewExpenses(jobResponses[projectIndex].data).map(job => job.id)

					if (serviceIndex !== false)
						vm.userServices = vm.filterToReviewExpenses(jobResponses[serviceIndex].data).map(job => job.id)

					vm.fetchExpenses(vm.showAllExpenses,false).then(response => {
						vm.spinner(false)
						vm.expensesLoaded = true

						if (vm.selectedPayPeriod === null)
							vm.selectedPayPeriod = 0
					})
				})

				vm.$store.timeLogSettings = responses[2].data[0]

			})
		}
	},
	created() {
		this.fetchData()
	}

}
</script>
